<template>
  <div class="card car-card">
    <div
      class="card-header car-info"
      :class="{active: isActive}"
      @click="onHeaderClick()"
    >
      <div
        class="car-type"
        :style="{'background':carType.colourCode}"
      />
      <h6 class="card-title">
        {{ name }}
      </h6>
    </div>
    <div class="card-body">
      <b-dropdown
        id="clear-dropdown"
        :text="booking ? $options.filters.formatDate(booking.date) : 'No allocations'"
        class="cars-dropdown full-width"
        variant="outline-dark"
        no-flip
        :disabled="!booking || (booking.status !== constants.bookingStatus.Accepted && booking.status !== constants.bookingStatus.Allocated)"
      >
        <b-dropdown-item @click="clearCallback(booking)">
          Clear
        </b-dropdown-item>
      </b-dropdown>
      <div class="d-flex justify-content-between align-items-center">
        <div
          class="alert car-msg-status"
          :class="{'alert-light': booking && booking.dispatchStatus === constants.bookingDispatchStatus.Unsent,
                   'alert-secondary': booking && booking.dispatchStatus === constants.bookingDispatchStatus.Sent,
                   'alert-primary': booking && booking.dispatchStatus === constants.bookingDispatchStatus.Delivered,
                   'alert-success': booking && booking.dispatchStatus === constants.bookingDispatchStatus.Accepted}"
          role="alert"
        >
          {{ booking && booking.dispatchStatus === constants.bookingDispatchStatus.Unsent ? 'U' : '' }}
          {{ booking && booking.dispatchStatus === constants.bookingDispatchStatus.Sent? 'S' : '' }}
          {{ booking && booking.dispatchStatus === constants.bookingDispatchStatus.Delivered ? 'D' : '' }}
          {{ booking && booking.dispatchStatus === constants.bookingDispatchStatus.Accepted ? 'A' : '' }}
        </div>
        <div class="custom-control form-control-lg custom-checkbox">
          <input
            :id="`customCheck${id}`"
            v-model="isCarWorking"
            type="checkbox"
            class="custom-control-input"
          >
          <label
            class="custom-control-label"
            :for="`customCheck${id}`"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import constants from "../../utils/Constants";
  
  export default {
    name: "CarCard",
    props: ['name', 'carType', 'isWorking', 'id','isActive','booking', 'clearCallback'],
    data(){
      return {
        isCarWorking : this.isWorking,
        constants: constants,
      }
    },
    watch:{
      isCarWorking: function(newValue,oldValue){
        this.$emit('car-working-change',newValue);
      }
    },
    methods:{
      onHeaderClick(){
        this.$emit('toggle')
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "@/assets/variables.scss";
  @import "bootstrap/scss/_functions.scss";
  @import "bootstrap/scss/_variables.scss";
  @import "bootstrap/scss/_mixins.scss";

  .card .car-card {
    .card-body {
      flex-grow: 0;
      background-color: $light-grey;
    }
  }

  .card-body {
    padding: 10px 10px 10px 10px;
  }

  .card-header {
    &.car-info {
      display: flex;
      flex-direction: row;
      justify-content: start;
      align-items: center;
      flex-basis: 51px;
      flex-grow: 1;
      flex-shrink: 0;
      padding: 6px 10px 6px 10px;
      background-color: $dark-grey;
      cursor: pointer;
      &.active{
        background-color: $selected;
        .card-title{
          color: $font-default;
        }
      }
    }
  }

  .car-card {
  }

  .card-title {
    margin-bottom: 0px;
    color: white;
  }

  .car-type {
    margin-right: 8px;
    flex-shrink: 0;
    width: 24px;
    height: 24px;
    border-radius: 50px;
    border: solid 1px rgba(0, 0, 0, 0.125);

  }

  .car-msg-status {
    margin-top: 8px;
    margin-bottom: 0px;
    padding: 2px 8px 2px 8px;
    width: 32px;
    height: 30px;
    text-align: center;
  }

  .custom-checkbox {
    height: auto;
    padding-top: 3px;
    padding-bottom: 5px;
    padding-right:6px;
  }

  .custom-control-label::before,
  .custom-control-label::after {
    top: 0.4rem;
    width: 30px;
    height: 30px;
  }

  .custom-control-input:checked ~ .custom-control-label::before {
    background-color: $dark-grey !important;
    border-color: $dark-grey !important;
  }

  .cars-dropdown {
    &.full-width {
      width: 100%;
    }
  }

  .cars-dropdown /deep/ button {
    padding-top: 0px;
    padding-bottom: 2px;

    &::after {
      vertical-align: 0.1em;
    }

    @include media-breakpoint-down(sm) {
      margin-bottom: 6px;
    }
  }

  .cars-dropdown /deep/ .dropdown-menu {
    width: 100%;
  }

  .cars-dropdown /deep/ .dropdown-menu .dropdown-item {
    display: flex;
    align-items: center;

    .car-msg-status {
      margin-top: 0px;
      margin-right: 6px;
    }
  }
</style>